import { onError } from "@apollo/client/link/error";
import { addBreadcrumb, type SeverityLevel } from "@sentry/react";

import { unauthorizedErrorRedirect } from "@helpers/unauthorizedErrorRedirect";
import { turnOffErrorReportingIfLoggedOut } from "@shared/utils/initSentry/filters/turnErrorsOff";

const getErrorLink = (notify?, disableUnauthorizedCheck?: boolean) => {
  return onError(({ graphQLErrors, networkError, response }) => {
    addBreadcrumb({
      category: "apolloOnError",
      data: {
        networkError: JSON.stringify(networkError),
        response: JSON.stringify(response),
        graphQLErrors: JSON.stringify(graphQLErrors),
      },
      level: "info" as SeverityLevel,
    });

    turnOffErrorReportingIfLoggedOut(networkError, response);

    // TODO: Ryan - remove whenever ErrorNotifierProvider is removed
    if (graphQLErrors && notify) {
      graphQLErrors.forEach(error => notify({ error }));
    }

    if (!disableUnauthorizedCheck) {
      unauthorizedErrorRedirect(networkError);
    }
  });
};

export { getErrorLink };
